<template>
  <div
    class="container-flex p-3"
    v-if="!isFetchingBudgetList"
  >
    <div class="UserDet d-flex justify-content-space-between align-items-center" v-if="budgetLoaded">
      <div class="UserDet-block">
        <div class="budget-header-block">
          <h1
            class="Tit Tit--userDet w-100 ellipsis"
            v-tooltip="budgetName"
          >
            {{ budgetName }}
          </h1>
          <budget-progress-bar
            :spent="budgetSpent"
            :assigned="budgetAssigned"
            :goal="budgetGoal"
          ></budget-progress-bar>
        </div>
        <div class="UserDet-info d-flex flex-nowrap">
          <span class="UserDet-infoItm">
            <span :class="{ 'status--yellow': isBudgetOwner }">
              {{ $t(budgetMembershipRenderLabel) }}</span></span>
          <span
            class="UserDet-infoItm"
            :class="{ 'status--red': budgetStatus === 'ARCHIVED' }"
          >
            <template v-if="budgetStatus">{{
              $t(`budgets_budget_status__${budgetStatus}`)
            }}</template></span>
          <span class="UserDet-infoItm">
            <template v-if="budgetCycle">{{
              $t(`budgets_budget_type__${budgetCycle}`)
            }}</template></span>
          <span class="UserDet-infoItm">
            <div
              class="Budgets-th Budget-th--black Budgets-th--dot"
              v-t="{ path: 'budget_detail_header_limit' }"
            ></div>
            <span class="amount">{{
                budgetGoal
                  | currency('€', 2, {
                    symbolOnLeft: false,
                    thousandsSeparator: '.',
                    decimalSeparator: ','
                  })
              }}
            </span>
          </span>
          <span class="UserDet-infoItm">
            <div
              class="Budgets-td Budgets-td--dot Budgets-td--dot--black"
              v-t="{ path: 'budget_detail_header_assigned' }"
            ></div>
            <span class="amount">
              {{
                budgetAssigned
                  | currency('€', 2, {
                    symbolOnLeft: false,
                    thousandsSeparator: '.',
                    decimalSeparator: ','
                  })
              }}
            </span>
          </span>
          <span class="UserDet-infoItm">
            <div
              class="Budgets-td Budgets-td--dot Budgets-td--dot--blue"
              v-t="{ path: 'budget_detail_header_spent' }"
            ></div>
            <span class="amount">
              {{
                budgetSpent
                  | currency('€', 2, {
                    symbolOnLeft: false,
                    thousandsSeparator: '.',
                    decimalSeparator: ','
                  })
              }}
            </span>
          </span>
        </div>
      </div>
      <div
        class="SecActions w-100 d-flex flex-nowrap justify-content-end align-items-center"
        v-if="!isUser && budgetStatus !== 'ARCHIVED'"
      >
        <button
          v-if="!isPlexus || isPlexus && isAdmin"
          @click="showBudgetSettingsModal"
          class="SecActions-link"
          v-t="{ path: 'budget_actions_budget_settings' }"
        ></button>
        <button
          @click="handleArchiveBudget"
          class="SecActions-link"
          v-t="{ path: 'budget_actions_archive_budget' }"
        ></button>
      </div>
    </div>

    <div class="CtrlsBar d-flex flex-wrap flex-md-nowrap justify-content-start align-items-center" v-if="budgetLoaded">
      <div class="d-flex w-100">
        <ul class="Submenu d-flex align-items-stretch mb-0">
          <li class="Submenu-itm">
            <router-link
              :to="`/budgets/detail/${budgetId}/expense-evolution`"
              class="Submenu-itmLink"
              active-class="Submenu-itmLink--curr"
              v-t="{ path: 'budget_detail_expense_evolution_tab' }"
            ></router-link>
          </li>

          <li class="Submenu-itm">
            <router-link
              :to="`/budgets/detail/${budgetId}/members`"
              class="Submenu-itmLink"
              active-class="Submenu-itmLink--curr"
              v-t="{ path: 'budget_detail_members_tab' }"
            ></router-link>
          </li>
          <li
            v-if="(!officeWithoutCards && !userWithoutCards) || (!officeWithoutCards && userWithoutCards && (isAdmin || isBookKeeper))"
            class="Submenu-itm"
          >
            <router-link
              :to="`/budgets/detail/${budgetId}/transactions`"
              class="Submenu-itmLink"
              active-class="Submenu-itmLink--curr"
              v-t="{ path: 'budget_detail_transactions_tab' }"
            ></router-link>
          </li>
          <li class="Submenu-itm">
            <router-link
              :to="`/budgets/detail/${budgetId}/reimbursements`"
              class="Submenu-itmLink"
              active-class="Submenu-itmLink--curr"
              v-t="{ path: 'budget_detail_reimbursements_tab' }"
            ></router-link>
          </li>
        </ul>
      </div>
      <div class="ml-auto d-flex flex-wrap flex-md-nowrap align-items-center flex-grow-1 flex-md-grow-0 justify-content-between justify-content-md-end mt-3 mt-md-0">
        <!-- TODO: Uncomment in beta
            <div class="Search flex-grow-1 mr-1 mr-sm-3"><i class="Search-ctrl">
                <svg focusable="false" aria-hidden="true" aria-label="Edit">
                  <use xlink:href="#search-icon"></use>
                </svg></i>
              <input class="Search-box" type="text" placeholder="Search...">
            </div>
            -->
        <div class="w-100 d-flex flex-column flex-md-row">

          <button
            class="Fuell-ToolbarButton blue"
            @click="showBudgetModal"
            v-if="(budgetStatus !== 'ARCHIVED' && !isPlexus) || (budgetStatus !== 'ARCHIVED' && isPlexus && isAdmin)"
          >
            <span
              data-modal="NewBudget"
              class="Fuell-ToolbarButton--label"
              v-t="{ path: 'budgets_add_members' }"
            ></span>
          </button>
          <button
            class="Fuell-ToolbarButton ml-md-3 ml-sm-0 blue"
            @click="showDownloadModal"
          >
            <span
              class="Fuell-ToolbarButton--label"
              v-t="{ path: 'transactions_action_download' }"
            >
            </span>
          </button>
        </div>
      </div>
    </div>
    <router-view
    @budgetLoaded="budgetLoaded = true"
    >

    </router-view>
    <budget-settings-modal
      :open.sync="showBudgetSettingsModalFlag"
      v-if="showBudgetSettingsModalFlag"
    ></budget-settings-modal>
    <create-budget-modal
      :budgetForUserChange="currentBudget"
      :open.sync="showBudgetModalFlag"
      v-if="showBudgetModalFlag"
    ></create-budget-modal>
    <confirm-modal
      :id="'confirm-archive-budget-modal'"
      v-if="showConfirmArchiveBudgetModalFlag"
      :title="'budget_confirm_archive_budget_header_action'"
      :message="''"
      ignoreDefaultMessage
      :acceptText="'budget_confirm_archive_budget_header_action'"
      :dismissText="'ACTION_CANCEL'"
      :open.sync="showConfirmArchiveBudgetModalFlag"
      @accept="archiveBudget"
      @dissmissCancel="hideConfirmModal"
    >
      <template
        v-slot:additional
        :extraInfo="budgetName"
      >
        <i18n
          tag="span"
          class="Fuell-Text"
          path="budget_confirm_archive_budget_text"
        >
          <template v-slot:budgetName>
            <span class="text-primary">{{budgetName}}</span>
          </template>
        </i18n>
      </template>
    </confirm-modal>
    <transactions-export-modal
      v-if="showTransactionDownloadModalFlag"
      :open.sync="showTransactionDownloadModalFlag"
      :downloadMode="true"
      :extraFilters="extraFilters"
      :transactionStatus="'OK'"
      @closeModal="removeHash"
    ></transactions-export-modal>
  </div>
  <div
    class="container-flex p-3"
    v-else
  >
    <div class="d-flex w-100 h-100 justify-content-center align-items-center">
      <spinner />
    </div>
  </div>
</template>

<script>
import { COMPANIES_WITH_SPECIFIC_FEATURES } from '@/modules/transactions/_constants/constants'
import { USER_CARDS_TYPE } from '@/constants/userCardsType'
import { OFFICE_CARDS_TYPE } from '@/constants/officeCardsType'
import _budgetDetailMixin from '../../_mixins/_budgetDetailMixin'
import BudgetProgressBar from '../../_components/_shared/BudgetProgressBar'
import Spinner from '@/components/Commons/Spinner'
const BudgetSettingsModal = () => import('../../_components/_shared/BudgetSettingsModal')
const CreateBudgetModal = () => import('../../_components/_shared/CreateBudgetModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
const TransactionsExportModal = () => import('../../../transactions/_components/_shared/TransactionsExportModal.vue')

export default {
  name: 'BudgetDetailIndex',
  mixins: [_budgetDetailMixin],
  components: { BudgetSettingsModal, BudgetProgressBar, CreateBudgetModal, ConfirmModal, Spinner, TransactionsExportModal },
  data () {
    return {
      showBudgetSettingsModalFlag: false,
      showBudgetModalFlag: false,
      showConfirmArchiveBudgetModalFlag: false,
      isFetchingBudgetList: false,
      markAsReviewInProgressFlag: false,
      markAsUnreviewInProgressFlag: false,
      showTransactionDownloadModalFlag: false,
      budgetLoaded: false,
      extraFilters: {
        exportTypeCode: 'DOWNLOAD',
        downloadTypeCode: 'BUDGETS',
        'budget.id': this.$route.params.id
      }
    }
  },
  computed: {
    userWithoutCards () {
      return this.$store.getters['UsersStore/userLogged'].userCardsType === USER_CARDS_TYPE.USER_CARDS_WITHOUT
    },
    officeWithoutCards () {
      return this.$store.getters['CompanyStore/currentCompany'].officeCardsType === OFFICE_CARDS_TYPE.OFFICE_CARDS_WITHOUT
    },
    budgetId () {
      return this.$route.params.id
    },
    currentBudget () {
      return this.$store.getters['BudgetsStore/currentBudget'] || false
    },
    budgets () {
      return this.$store.getters['BudgetsStore/budgets'] || []
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    isPlexus () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'PLEXUS')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isOwnerOfBudget () {
      return this.$store.getters['LoginStore/isOwnerOfAnyBudget']
    },
    isReviewer () {
      return this.$store.getters['LoginStore/isReviewer']
    }
  },
  methods: {
    removeHash () {
      if (window.location.hash === '#exportHistory') {
        window.location.hash = ''
      }
    },
    archiveBudget () {
      this.$store.dispatch('BudgetsStore/archiveBudget', this.budgetId)
    },
    showBudgetSettingsModal () {
      this.showBudgetSettingsModalFlag = true
    },
    showBudgetModal () {
      this.showBudgetModalFlag = true
    },
    handleArchiveBudget () {
      this.showConfirmArchiveBudgetModalFlag = true
    },
    hideConfirmModal () {
      this.showConfirmArchiveBudgetModalFlag = false
    },
    async showDownloadModal () {
      this.showTransactionDownloadModalFlag = true
    }
  },
  async created () {
    if (this.budgets.length === 0) {
      this.isFetchingBudgetList = true
      await this.$store.dispatch('BudgetsStore/fetchBudgets', false)
      this.isFetchingBudgetList = false
    }
  }
}
</script>

<style scoped>
.SecActions {
  top: 105px;
  right: 0px;
}
.progress {
  max-width: 512px !important;
}
.Tit--userDet {
  max-width: 325px;
}
.amount {
  padding: 0px 5px;
}
.budget-header-block {
  display: flex;
  align-items: center;
}
.Fuell-ToolbarButton:first-of-type {
  width: 152px;
}

@media screen and (max-width: 576px) {
  .budget-header-block {
    flex-direction: column;
    margin: 0px;
    align-items: unset;
  }
  .progress {
    width: 85vw;
  }
  .UserDet-info {
    flex-direction: column;
  }
  .UserDet-infoItm {
    justify-content: center;
    margin: 5px 0px;
  }
  .UserDet {
    flex-direction: column;
  }
  .SecActions {
    margin-top: 10px;
  }
  .SecActions-link {
    margin: 0px 4px;
    padding: 13px;
  }
  .Fuell-ToolbarButton {
    margin: 10px 0px;
    width: 100% !important;
    justify-content: center;
  }
}
</style>
